import { CardBodyStyled } from './CardBody.styles';

export const CardBody = CardBodyStyled;
